import { render, staticRenderFns } from "./YearCCData.vue?vue&type=template&id=fe59a454&scoped=true&"
import script from "./YearCCData.vue?vue&type=script&lang=js&"
export * from "./YearCCData.vue?vue&type=script&lang=js&"
import style0 from "./YearCCData.vue?vue&type=style&index=0&id=fe59a454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe59a454",
  null
  
)

export default component.exports